module.exports = __webpack_public_path__ + "static/media/front-porch.eeccd7b7.jpg";